<template>
    <div>

        <Header>
            <template #title>
                <i class="fad fa-pencil-ruler text-primary fa-fw mr-3"/>Úprava spotřebiče -
                {{ appliance.modelType.fullName }}
            </template>
            <template #buttons>
                <BackLinkButton :to="{ name: 'appliance_show', params: { appliance_id: appliance.id }}"/>
            </template>
        </Header>

        <div class="bg-white p-3 border-radius-sm">
            <div class="p-3 bg-light mb-3">
                <strong>Odběrné místo</strong>: {{ appliance.supplyPoint.id }}
                <span class="ml-3 mr-3">|</span>
                <strong>EAN:</strong> {{ appliance.supplyPoint.ean }}
            </div>

            <ApplianceForm
                v-bind:request="request"
                :is-processing="isProcessing"
                @submitted="onSubmitted"
            />

        </div>

    </div>
</template>

<script>
import {mapGetters} from "vuex"
import ApplianceForm from "./Component/ApplianceForm.vue"
import ApplianceRequest from "../../NewModel/Appliance/Request/ApplianceRequest"
import BackLinkButton from "../Common/UI/Button/BackLinkButton.vue"
import Header from "../Common/UI/Header.vue"

export default {

    components: {
        ApplianceForm,
        BackLinkButton,
        Header,
    },

    computed: {
        ...mapGetters({
            isProcessing: "appliance/isProcessing",
            hasAppliance: "appliance/hasAppliance",
            appliance: "appliance/getAppliance",
        }),
    },

    data() {
        return {
            request: new ApplianceRequest(),
        }
    },

    mounted() {
        this.request = ApplianceRequest.fromEntity(this.appliance)
    },

    methods: {

        /**
         * @param request : ApplianceRequest
         */
        onSubmitted(request) {
            this.$store.dispatch("appliance/updateAppliance", {
                id: this.appliance.id,
                request: request,
            })
                .then(() => {
                    this.successMessage('Úspěšně uloženo!')
                    this.$router.push({name: 'appliance_show'})
                    this.$router.push({
                        name: "appliance_show", params: {appliance_id: this.appliance.id,}
                    })
                        .catch(() => {
                        })
                })
                .catch((error) => {
                    this.warningMessage(error.response.data.message)
                })
        },

    },

}
</script>
